<template>
    <v-container class="container" fluid>
        <v-toolbar dark color="secondary">
            <v-spacer />
            <v-toolbar-title class="white--text"
                >Report Generetor</v-toolbar-title
            >
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider />
        <v-row>
            <v-col md="6" sm="12">
                <v-card>
                    <form>
                        <v-row class="px-5">
                            <v-combobox
                                v-model="reportData.Customer"
                                :items="customers"
                                :item-text="'Name'"
                                :item-value="'id'"
                                class="mx-3"
                                :rules="[v => !!v || 'Customer is required']"
                                required
                                auto-select-first
                                label="Customer"
                            ></v-combobox>
                        </v-row>
                        <v-row class="px-5">
                            <v-combobox
                                v-model="reportData.Station"
                                :items="stations"
                                :item-text="'Name'"
                                :item-value="'id'"
                                class="mx-3"
                                :rules="[v => !!v || 'Station is required']"
                                required
                                auto-select-first
                                label="Station"
                            ></v-combobox>
                        </v-row>
                        <v-row class="px-5">
                            <v-combobox
                                v-model="reportData.Terminal"
                                :items="terminals"
                                :item-text="'Name'"
                                :item-value="'id'"
                                class="mx-3"
                                :rules="[v => !!v || 'Terminal is required']"
                                required
                                auto-select-first
                                label="Terminal"
                            ></v-combobox>
                        </v-row>
                        <v-row class="justify-center">
                            <v-col cols="5">
                                <v-text-field
                                    label="Start Date"
                                    placeholder="yyyy-mm-dd"
                                    v-mask="'####/##/##'"
                                    :rules="dateRules"
                                    required
                                    type="tel"
                                    id="StartDate"
                                    :value="reportData.StartDate"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field
                                    label="End Date"
                                    placeholder="yyyy-mm-dd"
                                    v-mask="'####/##/##'"
                                    :rules="dateRules"
                                    type="tel"
                                    id="EndDate"
                                    :value="reportData.EndDate"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="justify-center">
                            <v-col cols="5">
                                <v-combobox
                                    v-model="reportData.Shift"
                                    :items="shift_headers"
                                    :item-text="'ShiftDate'"
                                    :item-value="'ShiftId'"
                                    label="Select Shift"
                                    class="mx-3"
                                    :rules="[
                                        v => !!v || 'Shift Date is required'
                                    ]"
                                    auto-select-first
                                >
                                </v-combobox>
                            </v-col>
                        </v-row>
                    </form>
                </v-card>
            </v-col>
            <v-divider />
            <v-col md="5" sm="12">
                <v-card>
                    <v-row class="px-4">
                        <v-col>
                            <v-btn elevation="2">
                                Daily Delivery Customer
                            </v-btn>
                        </v-col>
                        <v-col class="my-2">
                            Select Customer
                        </v-col>
                    </v-row>
                    <v-row class="px-4">
                        <v-col>
                            <v-btn elevation="2">
                                Daily Delivery Terminal
                            </v-btn>
                        </v-col>
                        <v-col class="my-2">
                            Select Customer and Terminal
                        </v-col>
                    </v-row>
                    <v-row class="px-4">
                        <v-col>
                            <v-btn elevation="2">
                                Daily Delivery Station
                            </v-btn>
                        </v-col>
                        <v-col class="my-2">
                            Select Customer and Station
                        </v-col>
                    </v-row>
                    <v-row class="px-4">
                        <v-col>
                            <v-btn elevation="2">
                                Missing Bol
                            </v-btn>
                        </v-col>
                        <v-col class="my-2">
                            Select Date Range
                        </v-col>
                    </v-row>
                    <v-row class="px-4">
                        <v-col>
                            <v-btn elevation="2">
                                Order Verification
                            </v-btn>
                        </v-col>
                        <v-col class="my-2">
                            Select Date Range
                        </v-col>
                    </v-row>
                    <v-row class="px-4">
                        <v-col>
                            <v-btn elevation="2">
                                Tracking Times
                            </v-btn>
                        </v-col>
                        <v-col class="my-2">
                            Select Date Range
                        </v-col>
                    </v-row>
                    <v-row class="px-4">
                        <v-col>
                            <v-btn elevation="2">
                                Search Loads for Driver
                            </v-btn>
                        </v-col>
                        <v-col class="my-2">
                            Select Date Range, Station Number
                        </v-col>
                    </v-row>
                    <v-row class="px-4">
                        <v-col>
                            <v-btn elevation="2">
                                Tagged Orders CK
                            </v-btn>
                        </v-col>
                        <v-col class="my-2">
                            Select Date Range
                        </v-col>
                    </v-row>
                    <v-row class="px-4">
                        <v-col>
                            <v-btn elevation="2">
                                Dispatch Principal Region
                            </v-btn>
                        </v-col>
                        <v-col class="my-2">
                            Select Shift and Principal Region
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ReportGenerator',
    data: function() {
        return {
            reportData: {},
            customers: [],
            stations: [],
            terminals: [],
            shift_headers: [],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ]
        };
    },

    mounted() {
        this.loadCustomers();
        this.loadStations();
        this.loadTerminals();
        this.loadShiftHeaders();
    },

    methods: {
        loadCustomers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data.data);
                    this.customers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadStations: function() {
            this.$store.state.isLoading = true;
            axios
                .get('station/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data.data);
                    this.stations = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadTerminals: function() {
            this.$store.state.isLoading = true;
            axios
                .get('terminal/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data.data);
                    this.terminals = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadShiftHeaders: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('shift-header/dates-sa', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.shift_headers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        }
    }
};
</script>
